import { BoundedRectangle } from '../../types/BoundedRectangle';

export default function getBoundedRectangleFromBbox(
  bbox: Array<number>,
): BoundedRectangle {
  return [
    [bbox[0], bbox[1]],
    [bbox[2], bbox[3]],
  ];
}
